import React from 'react'
import MapContainer from '../mapContainer/MapContainer'
import Site from './Site'

export default class Rionegro extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div>
        <Site dep="Antioquia" mun="Rionegro" dir="Kilómetro 33 Autopista Medellín - Bogotá, Vereda La Playa" tel="312 245 4575" />
        <MapContainer lat={6.203354} lng={-75.38215622} zoom={16.95}></MapContainer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/sites/Rionegro.jsx